export const FIELD_DOWNLOAD_UPDATES = 'FIELD_DOWNLOAD_UPDATES';
export const FIELD_SOFTWARE_UPDATES = 'FIELD_SOFTWARE_UPDATES';
export const FIELD_DATABASE_UPDATES = 'FIELD_DATABASE_UPDATES';
export const FIELD_DELETE_OLD_UPDATES = 'FIELD_DELETE_OLD_UPDATES';
export const FIELD_SCHEDULE = 'FIELD_SCHEDULE';
export const FIELD_SCHEDULE_FROM = 'FIELD_SCHEDULE_FROM';
export const FIELD_SCHEDULE_UNTIL = 'FIELD_SCHEDULE_UNTIL';
export const UPDATES_NEVER = 'UPDATES_NEVER';
export const UPDATES_SCHEDULED = 'UPDATES_SCHEDULED';
export const UPDATES_AVAILABLE = 'UPDATES_AVAILABLE';
export const DELETE_UPDATES_TRUE = 'DELETE_UPDATES_TRUE';
export const DELETE_UPDATES_FALSE = 'DELETE_UPDATES_FALSE';

export const SOFTWARE_UPDATE_PLACEHOLDER = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet mattis tortor, eu eleifend risus. Integer in tempus lorem, consectetur accumsan arcu. Nunc aliquam tincidunt nisi et lobortis. Integer ac justo a lacus maximus placerat. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse hendrerit mi a odio varius, id volutpat diam pellentesque. Nam fringilla eleifend fermentum. Aenean imperdiet, ante eu mollis laoreet, purus quam ornare odio, ac mollis ipsum felis vitae lorem. Praesent finibus placerat ex ut bibendum. In maximus, sem non feugiat tristique, lacus ligula commodo diam, eu dignissim dolor nunc sit amet mauris. Proin pellentesque arcu eu purus tincidunt, non ullamcorper augue finibus.';

export const DATE_FORMAT = 'DD MMM YYYY';

export const LICENSE_REGEX = /.{1,5}/g;

export const AWS_SECRET_ACCESS_KEY = /([a-zA-Z0-9+/]{40})/g;

export const AWS_ACCESS_KEY = /((?:ASIA|AKIA|AROA|AIDA)([A-Z0-7]{16}))/g;
